"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var buttons_1 = require("../buttons");
var Icon_1 = require("../Icon");
var Typography_1 = require("../Typography");
var NoContent = function (_a) {
    var hide = _a.hide, colSpan = _a.colSpan, renderNoContent = _a.renderNoContent, _b = _a.title, title = _b === void 0 ? 'No items found' : _b, text = _a.text, actions = _a.actions, dataTestId = _a["data-testid"], icon = _a.icon, iconColor = _a.iconColor;
    if (hide) {
        return null;
    }
    var content;
    if (renderNoContent) {
        content = renderNoContent();
    }
    else {
        content = ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-flex squid-flex-col squid-justify-center squid-items-center squid-py-[40px] md:squid-w-[350px]" }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: icon || 'FileQuestion02', size: "lg", highlight: "circle", fill: iconColor !== null && iconColor !== void 0 ? iconColor : 'base' }), (0, jsx_runtime_1.jsx)(Typography_1.Display, __assign({ as: "h3", size: "sm", color: "base", className: "squid-text-alias-font-display-sans-sm-font-size squid-text-center squid-mt-4" }, { children: title })), (0, jsx_runtime_1.jsx)(Typography_1.Body, __assign({ as: "h4", size: "sm", variant: "base", color: "weaker", className: "squid-text-center squid-mt-2" }, { children: text })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-flex squid-flex-col squid-gap-2 md:squid-flex-row squid-justify-evenly squid-mt-7 squid-w-full" }, { children: actions === null || actions === void 0 ? void 0 : actions.map(function (action, index) { return ((0, jsx_runtime_1.jsx)(buttons_1.Button, __assign({}, action), "no_content_".concat(index))); }) }))] })));
    }
    return ((0, jsx_runtime_1.jsx)("tbody", { children: (0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("td", __assign({ colSpan: colSpan }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-flex squid-justify-center squid-items-center", "data-testid": "".concat(dataTestId, "Empty") }, { children: content })) })) }) }));
};
exports.default = NoContent;
